import { useMediaQuery } from 'react-responsive';

export const useResponsive = (mediaQuery: string): boolean =>
  useMediaQuery({
    query: `(${mediaQuery})`,
  });
